import { baseURL } from "../http";

// OD-1524: every provider view is an access session in the Ogiso access log.
// The backend opens it when it issues the provider token
// (/skypointProvider/generate-token); this module sends the end signal when
// the user leaves provider view, and a heartbeat while they stay, so a session
// that never ends (crashed browser) is closed after the inactivity window.
//
// Requests use fetch with `keepalive` so they still go out while the page is
// unloading (tab closed, logout redirect). The Skypoint token is captured when
// the session starts: on localhost the provider iframe can overwrite the
// shared "token" cookie, and the session belongs to the Skypoint user.

export const PROVIDER_ACCESS_HEARTBEAT_MS = 5 * 60 * 1000;

let current = null; // { sessionId, authToken }

const post = (path, body, authToken) =>
  fetch(`${baseURL}${path}`, {
    method: "POST",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(body || {}),
  }).catch(() => {
    // Best effort: a session with no end signal is closed server-side.
  });

export const getProviderAccessAuthToken = () => current?.authToken;

export const beginProviderAccessSession = (sessionId, authToken) => {
  current = sessionId && authToken ? { sessionId, authToken } : null;
};

// Idempotent: the first end signal wins (e.g. logout, then the tab's pagehide).
export const endProviderAccessSession = (endReason) => {
  if (!current) return;
  const { sessionId, authToken } = current;
  current = null;
  post(`/skypointProvider/access-session/${sessionId}/end`, { endReason }, authToken);
};

export const heartbeatProviderAccessSession = () => {
  if (!current) return;
  post(
    `/skypointProvider/access-session/${current.sessionId}/heartbeat`,
    {},
    current.authToken
  );
};
